<template lang="pug">
    div(v-show="selected" :id="`scrollTarget-${name}`" class="tab-section")
        h2(class="sectionTitle text-gray-darkest capitalize")
            | {{name}}
        slot
</template>

<script>
export default {
    name: 'Tab',
    props: {
        name: {
            type: String,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="stylus" scoped>
.tab-section
    &.-hideTitle
        .sectionTitle
            display: none
</style>
